export enum EVALUATION_TYPE {
  TEMPLATE = "TEMPLATE",
  SMART_SUBSTITUTE = "SMART_SUBSTITUTE",
}
